"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListBatteryMinute = exports.ListBatteryDaily = exports.LIST_BATTERY_MINUTE = exports.LIST_BATTERY_DAILY = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LIST_BATTERY_MINUTE = '/v1/battery-minute-aggregated';
exports.LIST_BATTERY_MINUTE = LIST_BATTERY_MINUTE;
var LIST_BATTERY_DAILY = '/v1/battery-daily-aggregated';
exports.LIST_BATTERY_DAILY = LIST_BATTERY_DAILY;

var ListBatteryMinute = function ListBatteryMinute(prospectId, startDate, endDate, baseUrl, authToken) {
  return (0, _axios["default"])({
    url: "".concat(baseUrl).concat(LIST_BATTERY_MINUTE, "/").concat(prospectId),
    params: {
      startDate: startDate,
      endDate: endDate
    },
    headers: {
      Authorization: authToken
    }
  });
};

exports.ListBatteryMinute = ListBatteryMinute;

var ListBatteryDaily = function ListBatteryDaily(prospectId, startDate, endDate, baseUrl, authToken) {
  return (0, _axios["default"])({
    url: "".concat(baseUrl).concat(LIST_BATTERY_DAILY, "/").concat(prospectId),
    params: {
      startDate: startDate,
      endDate: endDate
    },
    headers: {
      Authorization: authToken
    }
  });
};

exports.ListBatteryDaily = ListBatteryDaily;